export default {
  user: {}
}
